import { combineReducers } from 'redux';
import layoutReducer from './layout/layoutState';
import authReducer from './auth/authState';
import crudReducer from './crud/crudState';
import reportReducer from './report/reportState';
import optionlistReducer from './optionlist/optionlistState';
import accessRightReducer from './accessright/accessRightState';
import userReducer from './user/userState';
import accessGroupReducer from './accessgroup/accessGroupState';
import moduleReducer from './module/moduleState';
import accessGroupUserReducer from './accessgroupuser/accessGroupUserState';
import jobRoleReducer from './jobapplicant/jobApplicantState';
import jobRoleRequestReducer from './jobrolerequest/jobRoleRequestState';
import jobPostReducer from './jobpost/jobPostState';
import myProfileReducer from './myprofile/myProfileState';
import jobApplicantReducer from './jobapplicant/jobApplicantState';
import referralReducer from './referral/referralState';

const rootReducer = combineReducers({
	layout: layoutReducer,
  	auth: authReducer,
  	crud: crudReducer,
  	report: reportReducer,
	optionlist: optionlistReducer,
	accessRight: accessRightReducer,
	user: userReducer,
	accessGroup: accessGroupReducer,
	module: moduleReducer,
	accessGroupUser: accessGroupUserReducer,
	jobRole: jobRoleReducer,
	jobRoleRequest: jobRoleRequestReducer,
	jobPost: jobPostReducer,
	myProfile: myProfileReducer,
	jobApplicant: jobApplicantReducer,
	referral: referralReducer
});

export default rootReducer;
